module.exports = __webpack_public_path__ + "static/media/Pranita-img.9b55f418.jpg";